import React, { useCallback } from 'react';
import styled from 'styled-components';

type Props = {
  inputClassName?: string;
  spanClassName?: string;
  isChecked?: boolean | undefined;
  isDisabled?: boolean | undefined;
  onChange?: Function | undefined;
  children: string;
};

export const CheckBox = ({ ...props }: Props) => {
  const { inputClassName, spanClassName, isChecked, isDisabled, onChange, children } = props;

  const wrapOnChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e);
      }
    },
    [onChange],
  );

  return (
    <Styled isChecked={isChecked}>
      <input
        className={inputClassName}
        type="checkbox"
        checked={isChecked}
        disabled={isDisabled}
        onChange={(e) => wrapOnChange(e)}
      />
      <span className={spanClassName}>{children}</span>
    </Styled>
  );
};

CheckBox.defaultProps = {
  isChecked: false,
  isDisabled: false,
};

type StyledProps = {
  isChecked: boolean | undefined;
};

const Styled = styled.label<StyledProps>`
  display: flex;
  align-items: center;
  > input {
    width: 20px;
    height: 20px;
    background: #fff;
    position: relative;
    appearance: none;
    cursor: pointer;
    &:after {
      content: '';
      display: ${({ isChecked }) => (isChecked ? 'block' : 'none')};
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: url('/images/icon/checked.svg');
      background-size: cover;
      margin: auto;
    }
  }
  > span {
    margin-left: 10px;
    cursor: pointer;
  }
`;

export default CheckBox;
